
let Flavours =[
	{
	  "id": "ccc22308-548f-4e28-bbff-0327b020c03f",
	  "monthlyRate": "5",
	  "type": "SCPU",
	  "planName": "1GB/1CPU/40GB",
	  "region": "SFO1",
	  "parenttype": "SCPU",
	  "ram": "1 GB",
	  "processor": "1 CPU",
	  "storage": "40 GB",
	  "hourlyRate": "0.0074",
	  "bandwidth": "1000000000000"
	},
	{
	  "id": "3844503c-e2ad-4809-a603-22db86fd61ea",
	  "monthlyRate": "10",
	  "type": "SCPU",
	  "planName": "2GB/1CPU/60GB",
	  "region": "SFO1",
	  "parenttype": "SCPU",
	  "ram": "2 GB",
	  "processor": "1 CPU",
	  "storage": "60 GB",
	  "hourlyRate": "0.0149",
	  "bandwidth": "2000000000000"
	},
	{
	  "id": "0158dd2e-ad9c-4097-97a8-b35b2f5deeac",
	  "monthlyRate": "20",
	  "type": "SCPU",
	  "planName": "4GB/2CPU/80GB",
	  "region": "SFO1",
	  "parenttype": "SCPU",
	  "ram": "4 GB",
	  "processor": "2 CPUs",
	  "storage": "80 GB",
	  "hourlyRate": "0.0298",
	  "bandwidth": "4000000000000"
	},
	{
	  "id": "5d992398-c72b-4d8d-af6c-8bd3765542d0",
	  "monthlyRate": "20",
	  "type": "MOF",
	  "planName": "16GB/2CPU/50GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "16 GB",
	  "processor": "2 CPUs",
	  "storage": "50 GB",
	  "hourlyRate": "0.0298",
	  "bandwidth": "4000000000000"
	},
	{
	  "id": "ab0fde35-4de6-4f79-97e4-7005844ceddc",
	  "monthlyRate": "20",
	  "type": "COF",
	  "planName": "4GB/2CPU/50GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "4 GB",
	  "processor": "2 CPUs",
	  "storage": "50 GB",
	  "hourlyRate": "0.0298",
	  "bandwidth": "4000000000000"
	},
	{
	  "id": "bf520078-8023-48f3-9563-e2ac4c5ba9bf",
	  "monthlyRate": "20",
	  "type": "DOF",
	  "planName": "16GB/2CPU/300GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "16 GB",
	  "processor": "2 CPUs",
	  "storage": "300 GB",
	  "hourlyRate": "0.0298",
	  "bandwidth": "4000000000000"
	},
	{
	  "id": "04e0b066-073a-49fa-8d54-cd717971ec6d",
	  "monthlyRate": "40",
	  "type": "SCPU",
	  "planName": "8GB/4CPU/160GB",
	  "region": "SFO1",
	  "parenttype": "SCPU",
	  "ram": "8 GB",
	  "processor": "4 CPUs",
	  "storage": "160 GB",
	  "hourlyRate": "0.0595",
	  "bandwidth": "5000000000000"
	},
	{
	  "id": "1b07c406-014f-49af-9851-d29f378eb1b5",
	  "monthlyRate": "40",
	  "type": "COF",
	  "planName": "8GB/4CPU/100GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "8 GB",
	  "processor": "4 CPUs",
	  "storage": "100 GB",
	  "hourlyRate": "0.0595",
	  "bandwidth": "5000000000000"
	},
	{
	  "id": "08ccda0f-6ebc-4604-9bab-72a57869c725",
	  "monthlyRate": "80",
	  "type": "COF",
	  "planName": "16GB/8CPU/200GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "16 GB",
	  "processor": "8 CPUs",
	  "storage": "200 GB",
	  "hourlyRate": "0.1190",
	  "bandwidth": "6000000000000"
	},
	{
	  "id": "4b8c04bd-2df2-4c5b-bc1e-8aff89bbd583",
	  "monthlyRate": "80",
	  "type": "DOF",
	  "planName": "32GB/4CPU/600GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "32 GB",
	  "processor": "4 CPUs",
	  "storage": "600 GB",
	  "hourlyRate": "0.1190",
	  "bandwidth": "6000000000000"
	},
	{
	  "id": "c534b8a0-5527-451b-8a71-1f605b43456a",
	  "monthlyRate": "80",
	  "type": "SCPU",
	  "planName": "16GB/8CPU/320GB",
	  "region": "SFO1",
	  "parenttype": "SCPU",
	  "ram": "16 GB",
	  "processor": "8 CPUs",
	  "storage": "320 GB",
	  "hourlyRate": "0.1190",
	  "bandwidth": "6000000000000"
	},
	{
	  "id": "e9f2bcaa-9114-42dd-afdd-0f03e3f68d0f",
	  "monthlyRate": "80",
	  "type": "MOF",
	  "planName": "32GB/4CPU/100GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "32 GB",
	  "processor": "4 CPUs",
	  "storage": "100 GB",
	  "hourlyRate": "0.1190",
	  "bandwidth": "6000000000000"
	},
	{
	  "id": "2a22a535-52f8-42f5-aa07-587244a7c15b",
	  "monthlyRate": "120",
	  "type": "COF",
	  "planName": "32GB/16CPU/400GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "32 GB",
	  "processor": "16 CPUs",
	  "storage": "400 GB",
	  "hourlyRate": "0.1786",
	  "bandwidth": "7000000000000"
	},
	{
	  "id": "583ece38-0e69-4c35-b8cf-05e92f754cf2",
	  "monthlyRate": "120",
	  "type": "DOF",
	  "planName": "64GB/8CPU/1200GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "64 GB",
	  "processor": "8 CPUs",
	  "storage": "1200 GB",
	  "hourlyRate": "0.1786",
	  "bandwidth": "7000000000000"
	},
	{
	  "id": "82b979ed-f8f0-4c63-a2b9-3328c411e91d",
	  "monthlyRate": "120",
	  "type": "MOF",
	  "planName": "64GB/8CPU/200GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "64 GB",
	  "processor": "8 CPUs",
	  "storage": "200 GB",
	  "hourlyRate": "0.1786",
	  "bandwidth": "7000000000000"
	},
	{
	  "id": "b054312a-268a-4dc2-a11a-c3ab889aa67d",
	  "monthlyRate": "120",
	  "type": "SCPU",
	  "planName": "24GB/12CPU/480GB",
	  "region": "SFO1",
	  "parenttype": "SCPU",
	  "ram": "24 GB",
	  "processor": "12 CPUs",
	  "storage": "480 GB",
	  "hourlyRate": "0.1786",
	  "bandwidth": "7000000000000"
	},
	{
	  "id": "2778fa95-8b8c-46a6-b7ac-ab88728c3312",
	  "monthlyRate": "160",
	  "type": "MOF",
	  "planName": "128GB/16CPU/400GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "128 GB",
	  "processor": "16 CPUs",
	  "storage": "400 GB",
	  "hourlyRate": "0.2381",
	  "bandwidth": "8000000000000"
	},
	{
	  "id": "56ce63b4-150b-46d2-bdf0-c4cd49ec3763",
	  "monthlyRate": "160",
	  "type": "DOF",
	  "planName": "128GB/16CPU/2400GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "128 GB",
	  "processor": "16 CPUs",
	  "storage": "2400 GB",
	  "hourlyRate": "0.2381",
	  "bandwidth": "8000000000000"
	},
	{
	  "id": "76e27af5-3b89-4654-9e6c-be71f914c13f",
	  "monthlyRate": "160",
	  "type": "SCPU",
	  "planName": "32GB/16CPU/640GB",
	  "region": "SFO1",
	  "parenttype": "SCPU",
	  "ram": "32 GB",
	  "processor": "16 CPUs",
	  "storage": "640 GB",
	  "hourlyRate": "0.2381",
	  "bandwidth": "8000000000000"
	},
	{
	  "id": "a04eb9e5-d46f-4ab3-ba46-6131085b808e",
	  "monthlyRate": "160",
	  "type": "COF",
	  "planName": "64GB/32CPU/800GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "64 GB",
	  "processor": "32 CPUs",
	  "storage": "800 GB",
	  "hourlyRate": "0.2381",
	  "bandwidth": "8000000000000"
	},
	{
	  "id": "15b33e24-92e1-4821-874c-232d4e50f897",
	  "monthlyRate": "200",
	  "type": "DOF",
	  "planName": "192GB/24CPU/3600GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "192 GB",
	  "processor": "24 CPUs",
	  "storage": "3600 GB",
	  "hourlyRate": "0.2976",
	  "bandwidth": "9000000000000"
	},
	{
	  "id": "a317e68f-5c54-4171-a159-008332780629",
	  "monthlyRate": "200",
	  "type": "SCPU",
	  "planName": "40GB/20CPU/800GB",
	  "region": "SFO1",
	  "parenttype": "SCPU",
	  "ram": "40 GB",
	  "processor": "20 CPUs",
	  "storage": "800 GB",
	  "hourlyRate": "0.2976",
	  "bandwidth": "9000000000000"
	},
	{
	  "id": "1e235f43-afc7-43da-b941-44c4a4ef8ef6",
	  "monthlyRate": "240",
	  "type": "SCPU",
	  "planName": "48GB/24CPU/960GB",
	  "region": "SFO1",
	  "parenttype": "SCPU",
	  "ram": "48 GB",
	  "processor": "24 CPUs",
	  "storage": "960 GB",
	  "hourlyRate": "0.3571",
	  "bandwidth": "10000000000000"
	},
	{
	  "id": "6dc4b220-c8b3-4219-840a-418da6c2c52a",
	  "monthlyRate": "240",
	  "type": "DOF",
	  "planName": "256GB/32CPU/7200GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "256 GB",
	  "processor": "32 CPUs",
	  "storage": "7200 GB",
	  "hourlyRate": "0.3571",
	  "bandwidth": "10000000000000"
	},
	{
	  "id": "a52d9301-d7a0-49d7-82a6-ac74e72a327a",
	  "monthlyRate": "240",
	  "type": "MOF",
	  "planName": "256GB/32CPU/800GB",
	  "region": "SFO1",
	  "parenttype": "DCPU",
	  "ram": "256 GB",
	  "processor": "32 CPUs",
	  "storage": "800 GB",
	  "hourlyRate": "0.3571",
	  "bandwidth": "10000000000000"
	},
	{
	  "id": "a171af9d-91fd-4a5a-9048-5025c45ca97b",
	  "monthlyRate": "280",
	  "type": "SCPU",
	  "planName": "56GB/28CPU/1120GB",
	  "region": "SFO1",
	  "parenttype": "SCPU",
	  "ram": "56 GB",
	  "processor": "28 CPUs",
	  "storage": "1120 GB",
	  "hourlyRate": "0.4167",
	  "bandwidth": "11000000000000"
	},
	{
	  "id": "dfdae548-45e0-45bf-9009-5098a5c2d7c0",
	  "monthlyRate": "320",
	  "type": "SCPU",
	  "planName": "64GB/32CPU/1280GB",
	  "region": "SFO1",
	  "parenttype": "SCPU",
	  "ram": "64 GB",
	  "processor": "32 CPUs",
	  "storage": "1280 GB",
	  "hourlyRate": "0.4762",
	  "bandwidth": "12000000000000"
	},
	{
		"id": "a171af9d-91fd-4a5a-9048-5025c45ca97b",
	  "monthlyRate": "185",
	  "type": "BM",
	  "planName": "32GB/6CPU/1024GB",
	  "region": "SFO1",
	  "parenttype": "BM",
	  "ram": "32 GB",
	  "processor": "6 CPUs",
	  "storage": "1024 GB",
	  "hourlyRate": "0.4167",
	  "bandwidth": "-1"
	},
	{
		"id": "a171af9d-91fd-4a5a-9048-5025c45ca97b",
	  "monthlyRate": "100",
	  "type": "SCPU",
	  "planName": "20GB/10CPU/400GB",
	  "region": "LA1",
	  "parenttype": "SCPU",
	  "ram": "20 GB",
	  "processor": "10 CPUs",
	  "storage": "400 GB",
	  "hourlyRate": "0.1488",
	  "bandwidth": "6500000000000"
	}
	
  ]

export default Flavours